module.exports = __webpack_public_path__ + "img/Logo Sanlam Allianz.2155b207.png";